export enum ETransactionColumnName {
  TRANSACTION = "TRANSACTION",
  CAPITAL_PROVIDER = "CAPITAL PROVIDER",
  FINANCING_PROGRAM = "FINANCING PROGRAM",
  TYPE = "TYPE",
  AMOUNT = "AMOUNT",
  DESCRIPTION = "DESCRIPTION",
  STATUS = "STATUS",
}
